const setObjectFieldByPath = (object, fieldPath, value) => {
  const parts = fieldPath.split(".");
  parts.forEach((part, index) => {
    if (index !== parts.length - 1) {
      if (!object[part]) {
        object[part] = {};
      }
      object = object[part];
    } else {
      object[part] = value;
    }
  });
};
function getMirrorObject(object) {
  return Object.keys(object)?.reduce(
    (result, key) => {
      const value = object[key];
      if (value) {
        result[value] = key;
      }
      return result;
    },
    {}
  );
}
const getValueByKey = (obj, key) => obj[key];
const isPrimitive = (item) => {
  return item !== Object(item);
};
const isNullOrUndefined = (item) => item === null || item === void 0;
const equals = (currentItem, newItem) => {
  if (isNullOrUndefined(currentItem)) {
    return currentItem === newItem;
  }
  if (isPrimitive(currentItem) && isPrimitive(newItem)) {
    return currentItem === newItem;
  }
  return currentItem === newItem || Object.keys(currentItem).every((prop) => {
    const key = prop;
    const isKeyExist = newItem && Object.prototype.hasOwnProperty.call(newItem, key);
    const compareArrays = (item1, item2) => {
      const array1 = Array.from(item1);
      const array2 = Array.from(item2);
      return array1.length === array2.length && array1.every((_, index) => array2.length > index ? equals(array1[index], array2[index]) : false);
    };
    const compare = (item1, item2, key2) => {
      const isObjectKey = typeof getValueByKey(item1, key2) === "object" && item1[key2];
      const isArray = Array.isArray(item1[key2]);
      return isObjectKey ? isArray ? compareArrays(item1[key2], item2[key2]) : equals(item1[key2], item2[key2]) : item1[key2] === item2[key2];
    };
    const isEqual = newItem && currentItem && compare(currentItem, newItem, key);
    return !isKeyExist || isEqual;
  });
};
function nameOf(key) {
  return key;
}
export {
  equals,
  getMirrorObject,
  isNullOrUndefined,
  nameOf,
  setObjectFieldByPath
};
//# sourceMappingURL=object.js.map
